/**
 * Fixed-width calendar-component padding for hand-assembled date/time strings. Pure-leaf module: NO value imports.
 *
 * Paired forbid-rule: `QUAL-INLINE-TWO-DIGIT-PAD-001`.
 */

/**
 * @runtime-derived-ssot-helper (const-leaf-pinned): the two-digit zero-pad every hand-assembled calendar string needs,
 * homed in const/ so pure utils/ leaves can value-import it without a forbidden cross-utils sibling dependency
 * (`QUAL-NO-RUNTIME-IMPORTS-IN-UTILS-001`, no allowlist) -- which is exactly what had forced a private copy into each
 * of the two `utils/market-maker/realauction-*` leaves that build auction date windows and local timestamps.
 *
 * DELIBERATELY NAMED for its width rather than the bare `pad` both copies used: a two-character-wide zero pad is the
 * only contract here, and a generic name in a shared const leaf invites a future caller to reach for it expecting a
 * configurable width. A caller needing another width uses `padStart` directly rather than widening this.
 *
 * Month/date/hour/minute components only -- it takes a NUMBER, so a caller must not hand it an already-formatted
 * string. Values above 99 pass through unpadded (`padStart` never truncates), which is the conservative direction:
 * an out-of-range component surfaces in the output rather than being silently clipped to two digits.
 */
export function padTwoDigits(n: number): string {
	return String(n).padStart(2, '0');
}
